import { render, staticRenderFns } from "./BarOrderModeSalon.vue?vue&type=template&id=a3520b32&scoped=true&"
import script from "./BarOrderModeSalon.vue?vue&type=script&lang=js&"
export * from "./BarOrderModeSalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3520b32",
  null
  
)

export default component.exports